export default __webpack_public_path__ + "static/media/main_wotty_hero_banner.2b377d3e.png";